import { b as T, n as Le, i as k, p as pt, c as J, d as It, e as Dr, f as dr, g as Pn, h as Ce, j as Ee, v as we, k as Me, a as X, l as De, o as _t, _ as B, q as Re, m as ut, s as Ot, r as Rr, t as ot, u as Ft, w as Be, x as z, y as rr, z as Fe, A as vt, B as Tn, C as je, S as Ie, D as _e, E as Oe, F as He, G as xn } from "./index-DpjUVRH2.mjs";
import * as dt from "react";
import Vn, { createContext as ft, useContext as _, useRef as Tt, useEffect as Z, useLayoutEffect as Ue, useCallback as Ke, useMemo as mr, forwardRef as Ne, createElement as Xe } from "react";
var W = function(t) {
  return {
    isEnabled: function(r) {
      return t.some(function(n) {
        return !!r[n];
      });
    }
  };
}, gr = {
  measureLayout: W([
    "layout",
    "layoutId",
    "drag",
    "_layoutResetTransform"
  ]),
  animation: W([
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag"
  ]),
  exit: W(["exit"]),
  drag: W(["drag", "dragControls"]),
  focus: W(["whileFocus"]),
  hover: W(["whileHover", "onHoverStart", "onHoverEnd"]),
  tap: W(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
  pan: W([
    "onPan",
    "onPanStart",
    "onPanSessionStart",
    "onPanEnd"
  ]),
  layoutAnimation: W(["layout", "layoutId"])
};
function Ge(t) {
  for (var r in t) {
    var n = t[r];
    n !== null && (gr[r].Component = n);
  }
}
var An = ft({ strict: !1 }), Sn = Object.keys(gr), Ye = Sn.length;
function ze(t, r, n) {
  var e = [];
  if (_(An), !r)
    return null;
  for (var a = 0; a < Ye; a++) {
    var i = Sn[a], o = gr[i], u = o.isEnabled, f = o.Component;
    u(t) && f && e.push(dt.createElement(f, T({ key: i }, t, { visualElement: r })));
  }
  return e;
}
var Xt = ft({
  transformPagePoint: function(t) {
    return t;
  },
  isStatic: !1
}), Gt = ft({});
function Ze() {
  return _(Gt).visualElement;
}
var Yt = ft(null);
function pr(t) {
  var r = Tt(null);
  return r.current === null && (r.current = t()), r.current;
}
function bn() {
  var t = _(Yt);
  if (t === null)
    return [!0, null];
  var r = t.isPresent, n = t.onExitComplete, e = t.register, a = Je();
  Z(function() {
    return e(a);
  }, []);
  var i = function() {
    return n == null ? void 0 : n(a);
  };
  return !r && n ? [!1, i] : [!0];
}
function $e(t) {
  return t === null ? !0 : t.isPresent;
}
var qe = 0, We = function() {
  return qe++;
}, Je = function() {
  return pr(We);
}, Qe = ft(null), bt = typeof window < "u", Br = bt ? Ue : Z;
function ke(t) {
  var r = t.layoutId, n = _(Qe);
  return n && r !== void 0 ? n + "-" + r : r;
}
function ta(t, r, n, e) {
  var a = _(Xt), i = _(An), o = Ze(), u = _(Yt), f = ke(n), s = Tt(void 0);
  e || (e = i.renderer), !s.current && e && (s.current = e(t, {
    visualState: r,
    parent: o,
    props: T(T({}, n), { layoutId: f }),
    presenceId: u == null ? void 0 : u.id,
    blockInitialAnimation: (u == null ? void 0 : u.initial) === !1
  }));
  var c = s.current;
  return Br(function() {
    c && (c.setProps(T(T(T({}, a), n), { layoutId: f })), c.isPresent = $e(u), c.isPresenceRoot = !o || o.presenceId !== (u == null ? void 0 : u.id), c.syncRender());
  }), Z(function() {
    var p;
    c && ((p = c.animationState) === null || p === void 0 || p.animateChanges());
  }), Br(function() {
    return function() {
      return c == null ? void 0 : c.notifyUnmount();
    };
  }, []), c;
}
function nr(t) {
  return typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current");
}
function ra(t, r, n) {
  return Ke(
    function(e) {
      var a;
      e && ((a = t.mount) === null || a === void 0 || a.call(t, e)), r && (e ? r.mount(e) : r.unmount()), n && (typeof n == "function" ? n(e) : nr(n) && (n.current = e));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [r]
  );
}
function Ln(t) {
  return Array.isArray(t);
}
function G(t) {
  return typeof t == "string" || Ln(t);
}
function na(t) {
  var r = {};
  return t.forEachValue(function(n, e) {
    return r[e] = n.get();
  }), r;
}
function ea(t) {
  var r = {};
  return t.forEachValue(function(n, e) {
    return r[e] = n.getVelocity();
  }), r;
}
function Cn(t, r, n, e, a) {
  var i;
  return e === void 0 && (e = {}), a === void 0 && (a = {}), typeof r == "string" && (r = (i = t.variants) === null || i === void 0 ? void 0 : i[r]), typeof r == "function" ? r(n ?? t.custom, e, a) : r;
}
function zt(t, r, n) {
  var e = t.getProps();
  return Cn(e, r, n ?? e.custom, na(t), ea(t));
}
function Zt(t) {
  var r;
  return typeof ((r = t.animate) === null || r === void 0 ? void 0 : r.start) == "function" || G(t.initial) || G(t.animate) || G(t.whileHover) || G(t.whileDrag) || G(t.whileTap) || G(t.whileFocus) || G(t.exit);
}
function En(t) {
  return !!(Zt(t) || t.variants);
}
function aa(t, r) {
  if (Zt(t)) {
    var n = t.initial, e = t.animate;
    return {
      initial: n === !1 || G(n) ? n : void 0,
      animate: G(e) ? e : void 0
    };
  }
  return t.inherit !== !1 ? r : {};
}
function ia(t, r) {
  var n = aa(t, _(Gt)), e = n.initial, a = n.animate;
  return mr(
    function() {
      return { initial: e, animate: a };
    },
    /**
     * Only break memoisation in static mode
     */
    r ? [
      Fr(e),
      Fr(a)
    ] : []
  );
}
function Fr(t) {
  return Array.isArray(t) ? t.join(" ") : t;
}
function oa(t) {
  var r = t.preloadedFeatures, n = t.createVisualElement, e = t.useRender, a = t.useVisualState, i = t.Component;
  r && Ge(r);
  function o(u, f) {
    var s = _(Xt).isStatic, c = null, p = ia(u, s), v = a(u, s);
    return !s && bt && (p.visualElement = ta(i, v, u, n), c = ze(u, p.visualElement)), dt.createElement(
      dt.Fragment,
      null,
      dt.createElement(Gt.Provider, { value: p }, e(i, u, ra(v, p.visualElement, f), v, s)),
      c
    );
  }
  return Ne(o);
}
function ua(t) {
  function r(e, a) {
    return a === void 0 && (a = {}), oa(t(e, a));
  }
  var n = /* @__PURE__ */ new Map();
  return new Proxy(r, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: function(e, a) {
      return n.has(a) || n.set(a, r(a)), n.get(a);
    }
  });
}
var sa = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "tspan",
  "use",
  "view"
];
function hr(t) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof t != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    t.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(sa.indexOf(t) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(t))
    )
  );
}
var yt = {};
function fa(t) {
  for (var r in t)
    yt[r] = t[r];
}
var la = ["", "X", "Y", "Z"], ca = ["translate", "scale", "rotate", "skew"], xt = ["transformPerspective", "x", "y", "z"];
ca.forEach(function(t) {
  return la.forEach(function(r) {
    return xt.push(t + r);
  });
});
function va(t, r) {
  return xt.indexOf(t) - xt.indexOf(r);
}
var da = new Set(xt);
function $t(t) {
  return da.has(t);
}
var ma = /* @__PURE__ */ new Set(["originX", "originY", "originZ"]);
function wn(t) {
  return ma.has(t);
}
function Mn(t, r) {
  var n = r.layout, e = r.layoutId;
  return $t(t) || wn(t) || (n || e !== void 0) && (!!yt[t] || t === "opacity");
}
var ga = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
function pa(t, r, n, e) {
  var a = t.transform, i = t.transformKeys, o = r.enableHardwareAcceleration, u = o === void 0 ? !0 : o, f = r.allowTransformNone, s = f === void 0 ? !0 : f, c = "";
  i.sort(va);
  for (var p = !1, v = i.length, g = 0; g < v; g++) {
    var l = i[g];
    c += (ga[l] || l) + "(" + a[l] + ") ", l === "z" && (p = !0);
  }
  return !p && u ? c += "translateZ(0)" : c = c.trim(), e ? c = e(a, n ? "" : c) : s && n && (c = "none"), c;
}
function ha(t) {
  var r = t.originX, n = r === void 0 ? "50%" : r, e = t.originY, a = e === void 0 ? "50%" : e, i = t.originZ, o = i === void 0 ? 0 : i;
  return n + " " + a + " " + o;
}
function Dn(t) {
  return t.startsWith("--");
}
var ya = function(t, r) {
  return r && typeof t == "number" ? r.transform(t) : t;
};
function yr(t, r, n, e, a, i, o, u) {
  var f, s = t.style, c = t.vars, p = t.transform, v = t.transformKeys, g = t.transformOrigin;
  v.length = 0;
  var l = !1, P = !1, m = !0;
  for (var h in r) {
    var V = r[h];
    if (Dn(h)) {
      c[h] = V;
      continue;
    }
    var C = Le[h], w = ya(V, C);
    if ($t(h)) {
      if (l = !0, p[h] = w, v.push(h), !m)
        continue;
      V !== ((f = C.default) !== null && f !== void 0 ? f : 0) && (m = !1);
    } else if (wn(h))
      g[h] = w, P = !0;
    else if (n != null && n.isHydrated && (e != null && e.isHydrated) && yt[h]) {
      var b = yt[h].process(V, e, n), S = yt[h].applyTo;
      if (S)
        for (var M = S.length, L = 0; L < M; L++)
          s[S[L]] = b;
      else
        s[h] = b;
    } else
      s[h] = w;
  }
  e && n && o && u ? (s.transform = o(e.deltaFinal, e.treeScale, l ? p : void 0), i && (s.transform = i(p, s.transform)), s.transformOrigin = u(e)) : (l && (s.transform = pa(t, a, m, i)), P && (s.transformOrigin = ha(g)));
}
var Pr = function() {
  return {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  };
};
function Rn(t, r, n) {
  for (var e in r)
    !k(r[e]) && !Mn(e, n) && (t[e] = r[e]);
}
function Pa(t, r, n) {
  var e = t.transformTemplate;
  return mr(function() {
    var a = Pr();
    yr(a, r, void 0, void 0, { enableHardwareAcceleration: !n }, e);
    var i = a.vars, o = a.style;
    return T(T({}, i), o);
  }, [r]);
}
function Ta(t, r, n) {
  var e = t.style || {}, a = {};
  return Rn(a, e, t), Object.assign(a, Pa(t, r, n)), t.transformValues && (a = t.transformValues(a)), a;
}
function xa(t, r, n) {
  var e = {}, a = Ta(t, r, n);
  return t.drag && (e.draggable = !1, a.userSelect = a.WebkitUserSelect = a.WebkitTouchCallout = "none", a.touchAction = t.drag === !0 ? "none" : "pan-" + (t.drag === "x" ? "y" : "x")), e.style = a, e;
}
var Va = /* @__PURE__ */ new Set([
  "initial",
  "animate",
  "exit",
  "style",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "layout",
  "layoutId",
  "_layoutResetTransform",
  "onLayoutAnimationComplete",
  "onViewportBoxUpdate",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "drag",
  "dragControls",
  "dragListener",
  "dragConstraints",
  "dragDirectionLock",
  "_dragX",
  "_dragY",
  "dragElastic",
  "dragMomentum",
  "dragPropagation",
  "dragTransition",
  "whileDrag",
  "onPan",
  "onPanStart",
  "onPanEnd",
  "onPanSessionStart",
  "onTap",
  "onTapStart",
  "onTapCancel",
  "onHoverStart",
  "onHoverEnd",
  "whileFocus",
  "whileTap",
  "whileHover"
]);
function Ht(t) {
  return Va.has(t);
}
var Bn = function(t) {
  return !Ht(t);
};
try {
  var Aa = require("@emotion/is-prop-valid").default;
  Bn = function(t) {
    return t.startsWith("on") ? !Ht(t) : Aa(t);
  };
} catch {
}
function Sa(t, r, n) {
  var e = {};
  for (var a in t)
    (Bn(a) || n === !0 && Ht(a) || !r && !Ht(a)) && (e[a] = t[a]);
  return e;
}
function jr(t, r, n) {
  return typeof t == "string" ? t : pt.transform(r + n * t);
}
function ba(t, r, n) {
  var e = jr(r, t.x, t.width), a = jr(n, t.y, t.height);
  return e + " " + a;
}
var Qt = function(t, r) {
  return pt.transform(t * r);
}, La = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function Ca(t, r, n, e, a, i) {
  e === void 0 && (e = 1), a === void 0 && (a = 0);
  var o = La;
  t[o.offset] = Qt(-a, r);
  var u = Qt(n, r), f = Qt(e, r);
  t[o.array] = u + " " + f;
}
function Tr(t, r, n, e, a, i, o, u) {
  var f = r.attrX, s = r.attrY, c = r.originX, p = r.originY, v = r.pathLength, g = r.pathSpacing, l = g === void 0 ? 1 : g, P = r.pathOffset, m = P === void 0 ? 0 : P, h = J(r, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
  yr(t, h, n, e, a, i, o, u), t.attrs = t.style, t.style = {};
  var V = t.attrs, C = t.style, w = t.dimensions, b = t.totalPathLength;
  V.transform && (w && (C.transform = V.transform), delete V.transform), w && (c !== void 0 || p !== void 0 || C.transform) && (C.transformOrigin = ba(w, c !== void 0 ? c : 0.5, p !== void 0 ? p : 0.5)), f !== void 0 && (V.x = f), s !== void 0 && (V.y = s), b !== void 0 && v !== void 0 && Ca(V, b, v, l, m);
}
var Fn = function() {
  return T(T({}, Pr()), { attrs: {} });
};
function Ea(t, r) {
  var n = mr(function() {
    var a = Fn();
    return Tr(a, r, void 0, void 0, { enableHardwareAcceleration: !1 }, t.transformTemplate), T(T({}, a.attrs), { style: T({}, a.style) });
  }, [r]);
  if (t.style) {
    var e = {};
    Rn(e, t.style, t), n.style = T(T({}, e), n.style);
  }
  return n;
}
function wa(t) {
  t === void 0 && (t = !1);
  var r = function(n, e, a, i, o) {
    var u = i.latestValues, f = hr(n) ? Ea : xa, s = f(e, u, o), c = Sa(e, typeof n == "string", t), p = T(T(T({}, c), s), { ref: a });
    return Xe(n, p);
  };
  return r;
}
var Ma = /([a-z])([A-Z])/g, Da = "$1-$2", jn = function(t) {
  return t.replace(Ma, Da).toLowerCase();
};
function In(t, r) {
  var n = r.style, e = r.vars;
  Object.assign(t.style, n);
  for (var a in e)
    t.style.setProperty(a, e[a]);
}
var _n = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform"
]);
function On(t, r) {
  In(t, r);
  for (var n in r.attrs)
    t.setAttribute(_n.has(n) ? n : jn(n), r.attrs[n]);
}
function xr(t) {
  var r = t.style, n = {};
  for (var e in r)
    (k(r[e]) || Mn(e, t)) && (n[e] = r[e]);
  return n;
}
function Hn(t) {
  var r = xr(t);
  for (var n in t)
    if (k(t[n])) {
      var e = n === "x" || n === "y" ? "attr" + n.toUpperCase() : n;
      r[e] = t[n];
    }
  return r;
}
function Vr(t) {
  return typeof t == "object" && typeof t.start == "function";
}
var Ra = function(t) {
  return !!(t && typeof t == "object" && t.mix && t.toValue);
}, Ba = function(t) {
  return It(t) ? t[t.length - 1] || 0 : t;
};
function Fa(t) {
  var r = k(t) ? t.get() : t;
  return Ra(r) ? r.toValue() : r;
}
function Ir(t, r, n, e) {
  var a = t.scrapeMotionValuesFromProps, i = t.createRenderState, o = t.onMount, u = {
    latestValues: ja(r, n, e, a),
    renderState: i()
  };
  return o && (u.mount = function(f) {
    return o(r, f, u);
  }), u;
}
var Un = function(t) {
  return function(r, n) {
    var e = _(Gt), a = _(Yt);
    return n ? Ir(t, r, e, a) : pr(function() {
      return Ir(t, r, e, a);
    });
  };
};
function ja(t, r, n, e) {
  var a = {}, i = (n == null ? void 0 : n.initial) === !1, o = e(t);
  for (var u in o)
    a[u] = Fa(o[u]);
  var f = t.initial, s = t.animate, c = Zt(t), p = En(t);
  r && p && !c && t.inherit !== !1 && (f ?? (f = r.initial), s ?? (s = r.animate));
  var v = i || f === !1 ? s : f;
  if (v && typeof v != "boolean" && !Vr(v)) {
    var g = Array.isArray(v) ? v : [v];
    g.forEach(function(l) {
      var P = Cn(t, l);
      if (P) {
        var m = P.transitionEnd;
        P.transition;
        var h = J(P, ["transitionEnd", "transition"]);
        for (var V in h)
          a[V] = h[V];
        for (var V in m)
          a[V] = m[V];
      }
    });
  }
  return a;
}
var Ia = {
  useVisualState: Un({
    scrapeMotionValuesFromProps: Hn,
    createRenderState: Fn,
    onMount: function(t, r, n) {
      var e = n.renderState, a = n.latestValues;
      try {
        e.dimensions = typeof r.getBBox == "function" ? r.getBBox() : r.getBoundingClientRect();
      } catch {
        e.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      _a(r) && (e.totalPathLength = r.getTotalLength()), Tr(e, a, void 0, void 0, { enableHardwareAcceleration: !1 }, t.transformTemplate), On(r, e);
    }
  })
};
function _a(t) {
  return t.tagName === "path";
}
var Oa = {
  useVisualState: Un({
    scrapeMotionValuesFromProps: xr,
    createRenderState: Pr
  })
};
function Ha(t, r, n, e) {
  var a = r.forwardMotionProps, i = a === void 0 ? !1 : a, o = hr(t) ? Ia : Oa;
  return T(T({}, o), {
    preloadedFeatures: n,
    useRender: wa(i),
    createVisualElement: e,
    Component: t
  });
}
var D;
(function(t) {
  t.Animate = "animate", t.Hover = "whileHover", t.Tap = "whileTap", t.Drag = "whileDrag", t.Focus = "whileFocus", t.Exit = "exit";
})(D || (D = {}));
function Ar(t, r, n, e) {
  return t.addEventListener(r, n, e), function() {
    return t.removeEventListener(r, n, e);
  };
}
function er(t, r, n, e) {
  Z(function() {
    var a = t.current;
    if (n && a)
      return Ar(a, r, n, e);
  }, [t, r, n, e]);
}
function Ua(t) {
  var r = t.whileFocus, n = t.visualElement, e = function() {
    var i;
    (i = n.animationState) === null || i === void 0 || i.setActive(D.Focus, !0);
  }, a = function() {
    var i;
    (i = n.animationState) === null || i === void 0 || i.setActive(D.Focus, !1);
  };
  er(n, "focus", r ? e : void 0), er(n, "blur", r ? a : void 0);
}
function Kn(t) {
  return typeof PointerEvent < "u" && t instanceof PointerEvent ? t.pointerType === "mouse" : t instanceof MouseEvent;
}
function Nn(t) {
  var r = !!t.touches;
  return r;
}
function Ka(t) {
  return function(r) {
    var n = r instanceof MouseEvent, e = !n || n && r.button === 0;
    e && t(r);
  };
}
var Na = { pageX: 0, pageY: 0 };
function Xa(t, r) {
  r === void 0 && (r = "page");
  var n = t.touches[0] || t.changedTouches[0], e = n || Na;
  return {
    x: e[r + "X"],
    y: e[r + "Y"]
  };
}
function Ga(t, r) {
  return r === void 0 && (r = "page"), {
    x: t[r + "X"],
    y: t[r + "Y"]
  };
}
function Sr(t, r) {
  return r === void 0 && (r = "page"), {
    point: Nn(t) ? Xa(t, r) : Ga(t, r)
  };
}
function Ya(t) {
  return Sr(t, "client");
}
var Xn = function(t, r) {
  r === void 0 && (r = !1);
  var n = function(e) {
    return t(e, Sr(e));
  };
  return r ? Ka(n) : n;
}, za = function() {
  return bt && window.onpointerdown === null;
}, Za = function() {
  return bt && window.ontouchstart === null;
}, $a = function() {
  return bt && window.onmousedown === null;
}, qa = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
}, Wa = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function Gn(t) {
  return za() ? t : Za() ? Wa[t] : $a() ? qa[t] : t;
}
function mt(t, r, n, e) {
  return Ar(t, Gn(r), Xn(n, r === "pointerdown"), e);
}
function Ut(t, r, n, e) {
  return er(t, Gn(r), n && Xn(n, r === "pointerdown"), e);
}
function Yn(t) {
  var r = null;
  return function() {
    var n = function() {
      r = null;
    };
    return r === null ? (r = t, n) : !1;
  };
}
var _r = Yn("dragHorizontal"), Or = Yn("dragVertical");
function zn(t) {
  var r = !1;
  if (t === "y")
    r = Or();
  else if (t === "x")
    r = _r();
  else {
    var n = _r(), e = Or();
    n && e ? r = function() {
      n(), e();
    } : (n && n(), e && e());
  }
  return r;
}
function Zn() {
  var t = zn(!0);
  return t ? (t(), !1) : !0;
}
function Hr(t, r, n) {
  return function(e, a) {
    var i;
    !Kn(e) || Zn() || (n == null || n(e, a), (i = t.animationState) === null || i === void 0 || i.setActive(D.Hover, r));
  };
}
function Ja(t) {
  var r = t.onHoverStart, n = t.onHoverEnd, e = t.whileHover, a = t.visualElement;
  Ut(a, "pointerenter", r || e ? Hr(a, !0, r) : void 0), Ut(a, "pointerleave", n || e ? Hr(a, !1, n) : void 0);
}
var $n = function(t, r) {
  return r ? t === r ? !0 : $n(t, r.parentElement) : !1;
};
function qn(t) {
  return Z(function() {
    return function() {
      return t();
    };
  }, []);
}
var ar = function(t) {
  return t.hasOwnProperty("x") && t.hasOwnProperty("y");
}, Ur = function(t) {
  return ar(t) && t.hasOwnProperty("z");
}, Mt = function(t, r) {
  return Math.abs(t - r);
};
function Wn(t, r) {
  if (Dr(t) && Dr(r))
    return Mt(t, r);
  if (ar(t) && ar(r)) {
    var n = Mt(t.x, r.x), e = Mt(t.y, r.y), a = Ur(t) && Ur(r) ? Mt(t.z, r.z) : 0;
    return Math.sqrt(Math.pow(n, 2) + Math.pow(e, 2) + Math.pow(a, 2));
  }
}
function Qa(t) {
  var r = t.onTap, n = t.onTapStart, e = t.onTapCancel, a = t.whileTap, i = t.visualElement, o = r || n || e || a, u = Tt(!1), f = Tt(null);
  function s() {
    var l;
    (l = f.current) === null || l === void 0 || l.call(f), f.current = null;
  }
  function c() {
    var l;
    return s(), u.current = !1, (l = i.animationState) === null || l === void 0 || l.setActive(D.Tap, !1), !Zn();
  }
  function p(l, P) {
    c() && ($n(i.getInstance(), l.target) ? r == null || r(l, P) : e == null || e(l, P));
  }
  function v(l, P) {
    c() && (e == null || e(l, P));
  }
  function g(l, P) {
    var m;
    s(), !u.current && (u.current = !0, f.current = dr(mt(window, "pointerup", p), mt(window, "pointercancel", v)), n == null || n(l, P), (m = i.animationState) === null || m === void 0 || m.setActive(D.Tap, !0));
  }
  Ut(i, "pointerdown", o ? g : void 0), qn(s);
}
var st = function(t) {
  return function(r) {
    return t(r), null;
  };
}, ka = {
  tap: st(Qa),
  focus: st(Ua),
  hover: st(Ja)
};
function Jn(t, r) {
  if (!Array.isArray(r))
    return !1;
  var n = r.length;
  if (n !== t.length)
    return !1;
  for (var e = 0; e < n; e++)
    if (r[e] !== t[e])
      return !1;
  return !0;
}
var ti = function(t) {
  return /^\-?\d*\.?\d+$/.test(t);
}, Qn = function(t) {
  return function(r) {
    return r.test(t);
  };
}, ri = {
  test: function(t) {
    return t === "auto";
  },
  parse: function(t) {
    return t;
  }
}, kn = [Pn, pt, Ce, Ee, we, Me, ri], Dt = function(t) {
  return kn.find(Qn(t));
}, ni = X(X([], B(kn)), [De, _t]), ei = function(t) {
  return ni.find(Qn(t));
};
function ai(t, r, n) {
  t.hasValue(r) ? t.getValue(r).set(n) : t.addValue(r, ut(n));
}
function ii(t, r) {
  var n = zt(t, r), e = n ? t.makeTargetAnimatable(n, !1) : {}, a = e.transitionEnd, i = a === void 0 ? {} : a;
  e.transition;
  var o = J(e, ["transitionEnd", "transition"]);
  o = T(T({}, o), i);
  for (var u in o) {
    var f = Ba(o[u]);
    ai(t, u, f);
  }
}
function oi(t, r, n) {
  var e, a, i, o, u = Object.keys(r).filter(function(g) {
    return !t.hasValue(g);
  }), f = u.length;
  if (f)
    for (var s = 0; s < f; s++) {
      var c = u[s], p = r[c], v = null;
      Array.isArray(p) && (v = p[0]), v === null && (v = (a = (e = n[c]) !== null && e !== void 0 ? e : t.readValue(c)) !== null && a !== void 0 ? a : r[c]), v != null && (typeof v == "string" && ti(v) ? v = parseFloat(v) : !ei(v) && _t.test(p) && (v = Re(c, p)), t.addValue(c, ut(v)), (i = (o = n)[c]) !== null && i !== void 0 || (o[c] = v), t.setBaseTarget(c, v));
    }
}
function ui(t, r) {
  if (r) {
    var n = r[t] || r.default || r;
    return n.from;
  }
}
function si(t, r, n) {
  var e, a, i = {};
  for (var o in t)
    i[o] = (e = ui(o, r)) !== null && e !== void 0 ? e : (a = n.getValue(o)) === null || a === void 0 ? void 0 : a.get();
  return i;
}
function fi(t, r, n) {
  n === void 0 && (n = {}), t.notifyAnimationStart();
  var e;
  if (Array.isArray(r)) {
    var a = r.map(function(o) {
      return ir(t, o, n);
    });
    e = Promise.all(a);
  } else if (typeof r == "string")
    e = ir(t, r, n);
  else {
    var i = typeof r == "function" ? zt(t, r, n.custom) : r;
    e = te(t, i, n);
  }
  return e.then(function() {
    return t.notifyAnimationComplete(r);
  });
}
function ir(t, r, n) {
  var e;
  n === void 0 && (n = {});
  var a = zt(t, r, n.custom), i = (a || {}).transition, o = i === void 0 ? t.getDefaultTransition() || {} : i;
  n.transitionOverride && (o = n.transitionOverride);
  var u = a ? function() {
    return te(t, a, n);
  } : function() {
    return Promise.resolve();
  }, f = !((e = t.variantChildren) === null || e === void 0) && e.size ? function(g) {
    g === void 0 && (g = 0);
    var l = o.delayChildren, P = l === void 0 ? 0 : l, m = o.staggerChildren, h = o.staggerDirection;
    return li(t, r, P + g, m, h, n);
  } : function() {
    return Promise.resolve();
  }, s = o.when;
  if (s) {
    var c = B(s === "beforeChildren" ? [u, f] : [f, u], 2), p = c[0], v = c[1];
    return p().then(v);
  } else
    return Promise.all([u(), f(n.delay)]);
}
function te(t, r, n) {
  var e, a = n === void 0 ? {} : n, i = a.delay, o = i === void 0 ? 0 : i, u = a.transitionOverride, f = a.type, s = t.makeTargetAnimatable(r), c = s.transition, p = c === void 0 ? t.getDefaultTransition() : c, v = s.transitionEnd, g = J(s, ["transition", "transitionEnd"]);
  u && (p = u);
  var l = [], P = f && ((e = t.animationState) === null || e === void 0 ? void 0 : e.getState()[f]);
  for (var m in g) {
    var h = t.getValue(m), V = g[m];
    if (!(!h || V === void 0 || P && vi(P, m))) {
      var C = Ot(m, h, V, T({ delay: o }, p));
      l.push(C);
    }
  }
  return Promise.all(l).then(function() {
    v && ii(t, v);
  });
}
function li(t, r, n, e, a, i) {
  n === void 0 && (n = 0), e === void 0 && (e = 0), a === void 0 && (a = 1);
  var o = [], u = (t.variantChildren.size - 1) * e, f = a === 1 ? function(s) {
    return s === void 0 && (s = 0), s * e;
  } : function(s) {
    return s === void 0 && (s = 0), u - s * e;
  };
  return Array.from(t.variantChildren).sort(ci).forEach(function(s, c) {
    o.push(ir(s, r, T(T({}, i), { delay: n + f(c) })).then(function() {
      return s.notifyAnimationComplete(r);
    }));
  }), Promise.all(o);
}
function ci(t, r) {
  return t.sortNodePosition(r);
}
function vi(t, r) {
  var n = t.protectedKeys, e = t.needsAnimating, a = n.hasOwnProperty(r) && e[r] !== !0;
  return e[r] = !1, a;
}
var br = [
  D.Animate,
  D.Hover,
  D.Tap,
  D.Drag,
  D.Focus,
  D.Exit
], di = X([], B(br)).reverse(), mi = br.length;
function gi(t) {
  return function(r) {
    return Promise.all(r.map(function(n) {
      var e = n.animation, a = n.options;
      return fi(t, e, a);
    }));
  };
}
function pi(t) {
  var r = gi(t), n = yi(), e = {}, a = !0, i = function(c, p) {
    var v = zt(t, p);
    if (v) {
      v.transition;
      var g = v.transitionEnd, l = J(v, ["transition", "transitionEnd"]);
      c = T(T(T({}, c), l), g);
    }
    return c;
  };
  function o(c) {
    return e[c] !== void 0;
  }
  function u(c) {
    r = c(t);
  }
  function f(c, p) {
    for (var v, g = t.getProps(), l = t.getVariantContext(!0) || {}, P = [], m = /* @__PURE__ */ new Set(), h = {}, V = 1 / 0, C = function(M) {
      var L = di[M], A = n[L], F = (v = g[L]) !== null && v !== void 0 ? v : l[L], H = G(F), $ = L === p ? A.isActive : null;
      $ === !1 && (V = M);
      var K = F === l[L] && F !== g[L] && H;
      if (K && a && t.manuallyAnimateOnMount && (K = !1), A.protectedKeys = T({}, h), // If it isn't active and hasn't *just* been set as inactive
      !A.isActive && $ === null || // If we didn't and don't have any defined prop for this animation type
      !F && !A.prevProp || // Or if the prop doesn't define an animation
      Vr(F) || typeof F == "boolean")
        return "continue";
      var j = hi(A.prevProp, F) || // If we're making this variant active, we want to always make it active
      L === p && A.isActive && !K && H || // If we removed a higher-priority variant (i is in reverse order)
      M > V && H, rt = Array.isArray(F) ? F : [F], q = rt.reduce(i, {});
      $ === !1 && (q = {});
      var Q = A.prevResolvedValues, nt = Q === void 0 ? {} : Q, Lt = T(T({}, nt), q), et = function(it) {
        j = !0, m.delete(it), A.needsAnimating[it] = !0;
      };
      for (var U in Lt) {
        var Y = q[U], at = nt[U];
        h.hasOwnProperty(U) || (Y !== at ? It(Y) && It(at) ? Jn(Y, at) ? A.protectedKeys[U] = !0 : et(U) : Y !== void 0 ? et(U) : m.add(U) : Y !== void 0 && m.has(U) ? et(U) : A.protectedKeys[U] = !0);
      }
      A.prevProp = F, A.prevResolvedValues = q, A.isActive && (h = T(T({}, h), q)), a && t.blockInitialAnimation && (j = !1), j && !K && P.push.apply(P, X([], B(rt.map(function(it) {
        return {
          animation: it,
          options: T({ type: L }, c)
        };
      }))));
    }, w = 0; w < mi; w++)
      C(w);
    if (e = T({}, h), m.size) {
      var b = {};
      m.forEach(function(M) {
        var L = t.getBaseTarget(M);
        L !== void 0 && (b[M] = L);
      }), P.push({ animation: b });
    }
    var S = !!P.length;
    return a && g.initial === !1 && !t.manuallyAnimateOnMount && (S = !1), a = !1, S ? r(P) : Promise.resolve();
  }
  function s(c, p, v) {
    var g;
    return n[c].isActive === p ? Promise.resolve() : ((g = t.variantChildren) === null || g === void 0 || g.forEach(function(l) {
      var P;
      return (P = l.animationState) === null || P === void 0 ? void 0 : P.setActive(c, p);
    }), n[c].isActive = p, f(v, c));
  }
  return {
    isAnimated: o,
    animateChanges: f,
    setActive: s,
    setAnimateFunction: u,
    getState: function() {
      return n;
    }
  };
}
function hi(t, r) {
  return typeof r == "string" ? r !== t : Ln(r) ? !Jn(r, t) : !1;
}
function lt(t) {
  return t === void 0 && (t = !1), {
    isActive: t,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function yi() {
  var t;
  return t = {}, t[D.Animate] = lt(!0), t[D.Hover] = lt(), t[D.Tap] = lt(), t[D.Drag] = lt(), t[D.Focus] = lt(), t[D.Exit] = lt(), t;
}
var Pi = {
  animation: st(function(t) {
    var r = t.visualElement, n = t.animate;
    r.animationState || (r.animationState = pi(r)), Vr(n) && Z(function() {
      return n.subscribe(r);
    }, [n]);
  }),
  exit: st(function(t) {
    var r = t.custom, n = t.visualElement, e = B(bn(), 2), a = e[0], i = e[1], o = _(Yt);
    Z(function() {
      var u, f, s = (u = n.animationState) === null || u === void 0 ? void 0 : u.setActive(D.Exit, !a, { custom: (f = o == null ? void 0 : o.custom) !== null && f !== void 0 ? f : r });
      !a && (s == null || s.then(i));
    }, [a]);
  })
}, re = (
  /** @class */
  function() {
    function t(r, n, e) {
      var a = this, i = e === void 0 ? {} : e, o = i.transformPagePoint;
      if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = function() {
        if (a.lastMoveEvent && a.lastMoveEventInfo) {
          var v = tr(a.lastMoveEventInfo, a.history), g = a.startEvent !== null, l = Wn(v.offset, { x: 0, y: 0 }) >= 3;
          if (!(!g && !l)) {
            var P = v.point, m = Rr().timestamp;
            a.history.push(T(T({}, P), { timestamp: m }));
            var h = a.handlers, V = h.onStart, C = h.onMove;
            g || (V && V(a.lastMoveEvent, v), a.startEvent = a.lastMoveEvent), C && C(a.lastMoveEvent, v);
          }
        }
      }, this.handlePointerMove = function(v, g) {
        if (a.lastMoveEvent = v, a.lastMoveEventInfo = kt(g, a.transformPagePoint), Kn(v) && v.buttons === 0) {
          a.handlePointerUp(v, g);
          return;
        }
        ot.update(a.updatePoint, !0);
      }, this.handlePointerUp = function(v, g) {
        a.end();
        var l = a.handlers, P = l.onEnd, m = l.onSessionEnd, h = tr(kt(g, a.transformPagePoint), a.history);
        a.startEvent && P && P(v, h), m && m(v, h);
      }, !(Nn(r) && r.touches.length > 1)) {
        this.handlers = n, this.transformPagePoint = o;
        var u = Sr(r), f = kt(u, this.transformPagePoint), s = f.point, c = Rr().timestamp;
        this.history = [T(T({}, s), { timestamp: c })];
        var p = n.onSessionStart;
        p && p(r, tr(f, this.history)), this.removeListeners = dr(mt(window, "pointermove", this.handlePointerMove), mt(window, "pointerup", this.handlePointerUp), mt(window, "pointercancel", this.handlePointerUp));
      }
    }
    return t.prototype.updateHandlers = function(r) {
      this.handlers = r;
    }, t.prototype.end = function() {
      this.removeListeners && this.removeListeners(), Ft.update(this.updatePoint);
    }, t;
  }()
);
function kt(t, r) {
  return r ? { point: r(t.point) } : t;
}
function Kr(t, r) {
  return { x: t.x - r.x, y: t.y - r.y };
}
function tr(t, r) {
  var n = t.point;
  return {
    point: n,
    delta: Kr(n, ne(r)),
    offset: Kr(n, Ti(r)),
    velocity: xi(r, 0.1)
  };
}
function Ti(t) {
  return t[0];
}
function ne(t) {
  return t[t.length - 1];
}
function xi(t, r) {
  if (t.length < 2)
    return { x: 0, y: 0 };
  for (var n = t.length - 1, e = null, a = ne(t); n >= 0 && (e = t[n], !(a.timestamp - e.timestamp > Be(r))); )
    n--;
  if (!e)
    return { x: 0, y: 0 };
  var i = (a.timestamp - e.timestamp) / 1e3;
  if (i === 0)
    return { x: 0, y: 0 };
  var o = {
    x: (a.x - e.x) / i,
    y: (a.y - e.y) / i
  };
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o;
}
function Vi(t) {
  return t;
}
function ee(t) {
  var r = t.top, n = t.left, e = t.right, a = t.bottom;
  return {
    x: { min: n, max: e },
    y: { min: r, max: a }
  };
}
function Ai(t) {
  var r = t.x, n = t.y;
  return {
    top: n.min,
    bottom: n.max,
    left: r.min,
    right: r.max
  };
}
function Si(t, r) {
  var n = t.top, e = t.left, a = t.bottom, i = t.right;
  r === void 0 && (r = Vi);
  var o = r({ x: e, y: n }), u = r({ x: i, y: a });
  return {
    top: o.y,
    left: o.x,
    bottom: u.y,
    right: u.x
  };
}
function tt() {
  return { x: { min: 0, max: 1 }, y: { min: 0, max: 1 } };
}
function bi(t) {
  return {
    x: T({}, t.x),
    y: T({}, t.y)
  };
}
var Nr = {
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
};
function Xr() {
  return {
    x: T({}, Nr),
    y: T({}, Nr)
  };
}
function O(t) {
  return [t("x"), t("y")];
}
function ae(t, r, n) {
  var e = r.min, a = r.max;
  return e !== void 0 && t < e ? t = n ? z(e, t, n.min) : Math.max(t, e) : a !== void 0 && t > a && (t = n ? z(a, t, n.max) : Math.min(t, a)), t;
}
function Li(t, r, n, e, a) {
  var i = t - r * n;
  return e ? ae(i, e, a) : i;
}
function Gr(t, r, n) {
  return {
    min: r !== void 0 ? t.min + r : void 0,
    max: n !== void 0 ? t.max + n - (t.max - t.min) : void 0
  };
}
function Ci(t, r) {
  var n = r.top, e = r.left, a = r.bottom, i = r.right;
  return {
    x: Gr(t.x, e, i),
    y: Gr(t.y, n, a)
  };
}
function Yr(t, r) {
  var n, e = r.min - t.min, a = r.max - t.max;
  return r.max - r.min < t.max - t.min && (n = B([a, e], 2), e = n[0], a = n[1]), {
    min: t.min + e,
    max: t.min + a
  };
}
function Ei(t, r) {
  return {
    x: Yr(t.x, r.x),
    y: Yr(t.y, r.y)
  };
}
function wi(t, r, n) {
  var e = t.max - t.min, a = z(r.min, r.max - e, n);
  return { min: a, max: a + e };
}
function Mi(t, r) {
  var n = {};
  return r.min !== void 0 && (n.min = r.min - t.min), r.max !== void 0 && (n.max = r.max - t.min), n;
}
var ie = 0.35;
function Di(t) {
  return t === !1 ? t = 0 : t === !0 && (t = ie), {
    x: zr(t, "left", "right"),
    y: zr(t, "top", "bottom")
  };
}
function zr(t, r, n) {
  return {
    min: Zr(t, r),
    max: Zr(t, n)
  };
}
function Zr(t, r) {
  var n;
  return typeof t == "number" ? t : (n = t[r]) !== null && n !== void 0 ? n : 0;
}
function oe(t, r) {
  var n = t.getBoundingClientRect();
  return ee(Si(n, r));
}
var Ri = function(t) {
  return Fe(0, 1, t);
};
function $r(t, r, n) {
  return r === void 0 && (r = 0), n === void 0 && (n = 0.01), Wn(t, r) < n;
}
function Vt(t) {
  return t.max - t.min;
}
function Bi(t, r) {
  var n = 0.5, e = Vt(t), a = Vt(r);
  return a > e ? n = rr(r.min, r.max - e, t.min) : e > a && (n = rr(t.min, t.max - a, r.min)), Ri(n);
}
function qr(t, r, n, e) {
  e === void 0 && (e = 0.5), t.origin = e, t.originPoint = z(r.min, r.max, t.origin), t.scale = Vt(n) / Vt(r), $r(t.scale, 1, 1e-4) && (t.scale = 1), t.translate = z(n.min, n.max, t.origin) - t.originPoint, $r(t.translate) && (t.translate = 0);
}
function ue(t, r, n, e) {
  qr(t.x, r.x, n.x, Wr(e.originX)), qr(t.y, r.y, n.y, Wr(e.originY));
}
function Wr(t) {
  return typeof t == "number" ? t : 0.5;
}
function Jr(t, r, n) {
  t.min = n.min + r.min, t.max = t.min + Vt(r);
}
function Fi(t, r) {
  Jr(t.target.x, t.relativeTarget.x, r.target.x), Jr(t.target.y, t.relativeTarget.y, r.target.y);
}
var Lr = function(t, r) {
  return t.depth - r.depth;
};
function se(t) {
  var r = t.projection.isEnabled;
  return r || t.shouldResetTransform();
}
function Kt(t, r) {
  r === void 0 && (r = []);
  var n = t.parent;
  return n && Kt(n, r), se(t) && r.push(t), r;
}
function ji(t) {
  var r = [], n = function(e) {
    se(e) && r.push(e), e.children.forEach(n);
  };
  return t.children.forEach(n), r.sort(Lr);
}
function jt(t) {
  if (!t.shouldResetTransform()) {
    var r = t.getLayoutState();
    t.notifyBeforeLayoutMeasure(r.layout), r.isHydrated = !0, r.layout = t.measureViewportBox(), r.layoutCorrected = bi(r.layout), t.notifyLayoutMeasure(r.layout, t.prevViewportBox || r.layout), ot.update(function() {
      return t.rebaseProjectionTarget();
    });
  }
}
function Ii(t) {
  t.shouldResetTransform() || (t.prevViewportBox = t.measureViewportBox(!1), t.rebaseProjectionTarget(!1, t.prevViewportBox));
}
function _i(t, r, n, e) {
  t.min = z(r.min, n.min, e), t.max = z(r.max, n.max, e);
}
function Qr(t, r) {
  return {
    min: r.min - t.min,
    max: r.max - t.min
  };
}
function gt(t, r) {
  return {
    x: Qr(t.x, r.x),
    y: Qr(t.y, r.y)
  };
}
function Oi(t, r) {
  var n = t.getLayoutId(), e = r.getLayoutId();
  return n !== e || e === void 0 && t !== r;
}
function fe(t) {
  var r = t.getProps(), n = r.drag, e = r._dragX;
  return n && !e;
}
function kr(t, r) {
  t.min = r.min, t.max = r.max;
}
function Hi(t, r) {
  kr(t.x, r.x), kr(t.y, r.y);
}
function Nt(t, r, n) {
  var e = t - n, a = r * e;
  return n + a;
}
function tn(t, r, n, e, a) {
  return a !== void 0 && (t = Nt(t, a, e)), Nt(t, n, e) + r;
}
function or(t, r, n, e, a) {
  r === void 0 && (r = 0), n === void 0 && (n = 1), t.min = tn(t.min, r, n, e, a), t.max = tn(t.max, r, n, e, a);
}
function Ui(t, r) {
  var n = r.x, e = r.y;
  or(t.x, n.translate, n.scale, n.originPoint), or(t.y, e.translate, e.scale, e.originPoint);
}
function rn(t, r, n, e) {
  var a = B(e, 3), i = a[0], o = a[1], u = a[2];
  t.min = r.min, t.max = r.max;
  var f = n[u] !== void 0 ? n[u] : 0.5, s = z(r.min, r.max, f);
  or(t, n[i], n[o], s, n.scale);
}
var le = ["x", "scaleX", "originX"], ce = ["y", "scaleY", "originY"];
function ur(t, r, n) {
  rn(t.x, r.x, n, le), rn(t.y, r.y, n, ce);
}
function nn(t, r, n, e, a) {
  return t -= r, t = Nt(t, 1 / n, e), a !== void 0 && (t = Nt(t, 1 / a, e)), t;
}
function Ki(t, r, n, e, a) {
  r === void 0 && (r = 0), n === void 0 && (n = 1), e === void 0 && (e = 0.5);
  var i = z(t.min, t.max, e) - r;
  t.min = nn(t.min, r, n, i, a), t.max = nn(t.max, r, n, i, a);
}
function en(t, r, n) {
  var e = B(n, 3), a = e[0], i = e[1], o = e[2];
  Ki(t, r[a], r[i], r[o], r.scale);
}
function ve(t, r) {
  en(t.x, r, le), en(t.y, r, ce);
}
function Ni(t, r, n) {
  var e = n.length;
  if (e) {
    r.x = r.y = 1;
    for (var a, i, o = 0; o < e; o++)
      a = n[o], i = a.getLayoutState().delta, r.x *= i.x.scale, r.y *= i.y.scale, Ui(t, i), fe(a) && ur(t, t, a.getLatestValues());
  }
}
function Xi(t, r) {
  r === void 0 && (r = !0);
  var n = t.getProjectionParent();
  if (!n)
    return !1;
  var e;
  return r ? (e = gt(n.projection.target, t.projection.target), ve(e, n.getLatestValues())) : e = gt(n.getLayoutState().layout, t.getLayoutState().layout), O(function(a) {
    return t.setProjectionTargetAxis(a, e[a].min, e[a].max, !0);
  }), !0;
}
var Pt = /* @__PURE__ */ new Set();
function an(t, r, n) {
  t[n] || (t[n] = []), t[n].push(r);
}
function sr(t) {
  return Pt.add(t), function() {
    return Pt.delete(t);
  };
}
function fr() {
  if (Pt.size) {
    var t = 0, r = [[]], n = [], e = function(u) {
      return an(r, u, t);
    }, a = function(u) {
      an(n, u, t), t++;
    };
    Pt.forEach(function(u) {
      u(e, a), t = 0;
    }), Pt.clear();
    for (var i = n.length, o = 0; o <= i; o++)
      r[o] && r[o].forEach(on), n[o] && n[o].forEach(on);
  }
}
var on = function(t) {
  return t();
}, Gi = /* @__PURE__ */ new WeakMap(), un, Yi = (
  /** @class */
  function() {
    function t(r) {
      var n = r.visualElement;
      this.isDragging = !1, this.currentDirection = null, this.constraints = !1, this.elastic = tt(), this.props = {}, this.hasMutatedConstraints = !1, this.cursorProgress = {
        x: 0.5,
        y: 0.5
      }, this.originPoint = {}, this.openGlobalLock = null, this.panSession = null, this.visualElement = n, this.visualElement.enableLayoutProjection(), Gi.set(n, this);
    }
    return t.prototype.start = function(r, n) {
      var e = this, a = n === void 0 ? {} : n, i = a.snapToCursor, o = i === void 0 ? !1 : i, u = a.cursorProgress, f = function(g) {
        var l;
        e.stopMotion();
        var P = Ya(g).point;
        (l = e.cancelLayout) === null || l === void 0 || l.call(e), e.cancelLayout = sr(function(m, h) {
          var V = Kt(e.visualElement), C = ji(e.visualElement), w = X(X([], B(V)), B(C)), b = !1;
          e.isLayoutDrag() && e.visualElement.lockProjectionTarget(), h(function() {
            w.forEach(function(S) {
              return S.resetTransform();
            });
          }), m(function() {
            jt(e.visualElement), C.forEach(jt);
          }), h(function() {
            w.forEach(function(S) {
              return S.restoreTransform();
            }), o && (b = e.snapToCursor(P));
          }), m(function() {
            var S = !!(e.getAxisMotionValue("x") && !e.isExternalDrag());
            S || e.visualElement.rebaseProjectionTarget(!0, e.visualElement.measureViewportBox(!1)), e.visualElement.scheduleUpdateLayoutProjection();
            var M = e.visualElement.projection;
            O(function(L) {
              if (!b) {
                var A = M.target[L], F = A.min, H = A.max;
                e.cursorProgress[L] = u ? u[L] : rr(F, H, P[L]);
              }
              var $ = e.getAxisMotionValue(L);
              $ && (e.originPoint[L] = $.get());
            });
          }), h(function() {
            vt.update(), vt.preRender(), vt.render(), vt.postRender();
          }), m(function() {
            return e.resolveDragConstraints();
          });
        });
      }, s = function(g, l) {
        var P, m, h, V = e.props, C = V.drag, w = V.dragPropagation;
        C && !w && (e.openGlobalLock && e.openGlobalLock(), e.openGlobalLock = zn(C), !e.openGlobalLock) || (fr(), e.isDragging = !0, e.currentDirection = null, (m = (P = e.props).onDragStart) === null || m === void 0 || m.call(P, g, l), (h = e.visualElement.animationState) === null || h === void 0 || h.setActive(D.Drag, !0));
      }, c = function(g, l) {
        var P, m, h, V, C = e.props, w = C.dragPropagation, b = C.dragDirectionLock;
        if (!(!w && !e.openGlobalLock)) {
          var S = l.offset;
          if (b && e.currentDirection === null) {
            e.currentDirection = zi(S), e.currentDirection !== null && ((m = (P = e.props).onDirectionLock) === null || m === void 0 || m.call(P, e.currentDirection));
            return;
          }
          e.updateAxis("x", l.point, S), e.updateAxis("y", l.point, S), (V = (h = e.props).onDrag) === null || V === void 0 || V.call(h, g, l), un = g;
        }
      }, p = function(g, l) {
        return e.stop(g, l);
      }, v = this.props.transformPagePoint;
      this.panSession = new re(r, {
        onSessionStart: f,
        onStart: s,
        onMove: c,
        onSessionEnd: p
      }, { transformPagePoint: v });
    }, t.prototype.resolveDragConstraints = function() {
      var r = this, n = this.props, e = n.dragConstraints, a = n.dragElastic, i = this.visualElement.getLayoutState().layoutCorrected;
      e ? this.constraints = nr(e) ? this.resolveRefConstraints(i, e) : Ci(i, e) : this.constraints = !1, this.elastic = Di(a), this.constraints && !this.hasMutatedConstraints && O(function(o) {
        r.getAxisMotionValue(o) && (r.constraints[o] = Mi(i[o], r.constraints[o]));
      });
    }, t.prototype.resolveRefConstraints = function(r, n) {
      var e = this.props, a = e.onMeasureDragConstraints, i = e.transformPagePoint, o = n.current;
      this.constraintsBox = oe(o, i);
      var u = Ei(r, this.constraintsBox);
      if (a) {
        var f = a(Ai(u));
        this.hasMutatedConstraints = !!f, f && (u = ee(f));
      }
      return u;
    }, t.prototype.cancelDrag = function() {
      var r, n;
      this.visualElement.unlockProjectionTarget(), (r = this.cancelLayout) === null || r === void 0 || r.call(this), this.isDragging = !1, this.panSession && this.panSession.end(), this.panSession = null, !this.props.dragPropagation && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), (n = this.visualElement.animationState) === null || n === void 0 || n.setActive(D.Drag, !1);
    }, t.prototype.stop = function(r, n) {
      var e, a, i;
      (e = this.panSession) === null || e === void 0 || e.end(), this.panSession = null;
      var o = this.isDragging;
      if (this.cancelDrag(), !!o) {
        var u = n.velocity;
        this.animateDragEnd(u), (i = (a = this.props).onDragEnd) === null || i === void 0 || i.call(a, r, n);
      }
    }, t.prototype.snapToCursor = function(r) {
      var n = this;
      return O(function(e) {
        var a = n.props.drag;
        if (Rt(e, a, n.currentDirection)) {
          var i = n.getAxisMotionValue(e);
          if (i) {
            var o = n.visualElement.getLayoutState().layout, u = o[e].max - o[e].min, f = o[e].min + u / 2, s = r[e] - f;
            n.originPoint[e] = r[e], i.set(s);
          } else
            return n.cursorProgress[e] = 0.5, !0;
        }
      }).includes(!0);
    }, t.prototype.updateAxis = function(r, n, e) {
      var a = this.props.drag;
      if (Rt(r, a, this.currentDirection))
        return this.getAxisMotionValue(r) ? this.updateAxisMotionValue(r, e) : this.updateVisualElementAxis(r, n);
    }, t.prototype.updateAxisMotionValue = function(r, n) {
      var e = this.getAxisMotionValue(r);
      if (!(!n || !e)) {
        var a = this.originPoint[r] + n[r], i = this.constraints ? ae(a, this.constraints[r], this.elastic[r]) : a;
        e.set(i);
      }
    }, t.prototype.updateVisualElementAxis = function(r, n) {
      var e, a = this.visualElement.getLayoutState().layout[r], i = a.max - a.min, o = this.cursorProgress[r], u = Li(n[r], i, o, (e = this.constraints) === null || e === void 0 ? void 0 : e[r], this.elastic[r]);
      this.visualElement.setProjectionTargetAxis(r, u, u + i);
    }, t.prototype.setProps = function(r) {
      var n = r.drag, e = n === void 0 ? !1 : n, a = r.dragDirectionLock, i = a === void 0 ? !1 : a, o = r.dragPropagation, u = o === void 0 ? !1 : o, f = r.dragConstraints, s = f === void 0 ? !1 : f, c = r.dragElastic, p = c === void 0 ? ie : c, v = r.dragMomentum, g = v === void 0 ? !0 : v, l = J(r, ["drag", "dragDirectionLock", "dragPropagation", "dragConstraints", "dragElastic", "dragMomentum"]);
      this.props = T({
        drag: e,
        dragDirectionLock: i,
        dragPropagation: u,
        dragConstraints: s,
        dragElastic: p,
        dragMomentum: g
      }, l);
    }, t.prototype.getAxisMotionValue = function(r) {
      var n = this.props, e = n.layout, a = n.layoutId, i = "_drag" + r.toUpperCase();
      if (this.props[i])
        return this.props[i];
      if (!e && a === void 0)
        return this.visualElement.getValue(r, 0);
    }, t.prototype.isLayoutDrag = function() {
      return !this.getAxisMotionValue("x");
    }, t.prototype.isExternalDrag = function() {
      var r = this.props, n = r._dragX, e = r._dragY;
      return n || e;
    }, t.prototype.animateDragEnd = function(r) {
      var n = this, e = this.props, a = e.drag, i = e.dragMomentum, o = e.dragElastic, u = e.dragTransition, f = Xi(this.visualElement, this.isLayoutDrag() && !this.isExternalDrag()), s = this.constraints || {};
      if (f && Object.keys(s).length && this.isLayoutDrag()) {
        var c = this.visualElement.getProjectionParent();
        if (c) {
          var p = gt(c.projection.targetFinal, s);
          O(function(g) {
            var l = p[g], P = l.min, m = l.max;
            s[g] = {
              min: isNaN(P) ? void 0 : P,
              max: isNaN(m) ? void 0 : m
            };
          });
        }
      }
      var v = O(function(g) {
        var l;
        if (Rt(g, a, n.currentDirection)) {
          var P = (l = s == null ? void 0 : s[g]) !== null && l !== void 0 ? l : {}, m = o ? 200 : 1e6, h = o ? 40 : 1e7, V = T(T({
            type: "inertia",
            velocity: i ? r[g] : 0,
            bounceStiffness: m,
            bounceDamping: h,
            timeConstant: 750,
            restDelta: 1,
            restSpeed: 10
          }, u), P);
          return n.getAxisMotionValue(g) ? n.startAxisValueAnimation(g, V) : n.visualElement.startLayoutAnimation(g, V, f);
        }
      });
      return Promise.all(v).then(function() {
        var g, l;
        (l = (g = n.props).onDragTransitionEnd) === null || l === void 0 || l.call(g);
      });
    }, t.prototype.stopMotion = function() {
      var r = this;
      O(function(n) {
        var e = r.getAxisMotionValue(n);
        e ? e.stop() : r.visualElement.stopLayoutAnimation();
      });
    }, t.prototype.startAxisValueAnimation = function(r, n) {
      var e = this.getAxisMotionValue(r);
      if (e) {
        var a = e.get();
        return e.set(a), e.set(a), Ot(r, e, 0, n);
      }
    }, t.prototype.scalePoint = function() {
      var r = this, n = this.props, e = n.drag, a = n.dragConstraints;
      if (!(!nr(a) || !this.constraintsBox)) {
        this.stopMotion();
        var i = { x: 0, y: 0 };
        O(function(o) {
          i[o] = Bi(r.visualElement.projection.target[o], r.constraintsBox[o]);
        }), this.updateConstraints(function() {
          O(function(o) {
            if (Rt(o, e, null)) {
              var u = wi(r.visualElement.projection.target[o], r.constraintsBox[o], i[o]), f = u.min, s = u.max;
              r.visualElement.setProjectionTargetAxis(o, f, s);
            }
          });
        }), setTimeout(fr, 1);
      }
    }, t.prototype.updateConstraints = function(r) {
      var n = this;
      this.cancelLayout = sr(function(e, a) {
        var i = Kt(n.visualElement);
        a(function() {
          return i.forEach(function(o) {
            return o.resetTransform();
          });
        }), e(function() {
          return jt(n.visualElement);
        }), a(function() {
          return i.forEach(function(o) {
            return o.restoreTransform();
          });
        }), e(function() {
          n.resolveDragConstraints();
        }), r && a(r);
      });
    }, t.prototype.mount = function(r) {
      var n = this, e = r.getInstance(), a = mt(e, "pointerdown", function(f) {
        var s = n.props, c = s.drag, p = s.dragListener, v = p === void 0 ? !0 : p;
        c && v && n.start(f);
      }), i = Ar(window, "resize", function() {
        n.scalePoint();
      }), o = r.onLayoutUpdate(function() {
        n.isDragging && n.resolveDragConstraints();
      }), u = r.prevDragCursor;
      return u && this.start(un, { cursorProgress: u }), function() {
        a == null || a(), i == null || i(), o == null || o(), n.cancelDrag();
      };
    }, t;
  }()
);
function Rt(t, r, n) {
  return (r === !0 || r === t) && (n === null || n === t);
}
function zi(t, r) {
  r === void 0 && (r = 10);
  var n = null;
  return Math.abs(t.y) > r ? n = "y" : Math.abs(t.x) > r && (n = "x"), n;
}
function Zi(t) {
  var r = t.dragControls, n = t.visualElement, e = _(Xt).transformPagePoint, a = pr(function() {
    return new Yi({
      visualElement: n
    });
  });
  a.setProps(T(T({}, t), { transformPagePoint: e })), Z(function() {
    return r && r.subscribe(a);
  }, [a]), Z(function() {
    return a.mount(n);
  }, []);
}
function $i(t) {
  var r = t.onPan, n = t.onPanStart, e = t.onPanEnd, a = t.onPanSessionStart, i = t.visualElement, o = r || n || e || a, u = Tt(null), f = _(Xt).transformPagePoint, s = {
    onSessionStart: a,
    onStart: n,
    onMove: r,
    onEnd: function(p, v) {
      u.current = null, e && e(p, v);
    }
  };
  Z(function() {
    u.current !== null && u.current.updateHandlers(s);
  });
  function c(p) {
    u.current = new re(p, s, {
      transformPagePoint: f
    });
  }
  Ut(i, "pointerdown", o && c), qn(function() {
    return u.current && u.current.end();
  });
}
var qi = {
  pan: st($i),
  drag: st(Zi)
}, At;
(function(t) {
  t[t.Entering = 0] = "Entering", t[t.Present = 1] = "Present", t[t.Exiting = 2] = "Exiting";
})(At || (At = {}));
var lr;
(function(t) {
  t[t.Hide = 0] = "Hide", t[t.Show = 1] = "Show";
})(lr || (lr = {}));
function cr(t) {
  return typeof t == "string" && t.startsWith("var(--");
}
var de = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function Wi(t) {
  var r = de.exec(t);
  if (!r)
    return [,];
  var n = B(r, 3), e = n[1], a = n[2];
  return [e, a];
}
function vr(t, r, n) {
  var e = B(Wi(t), 2), a = e[0], i = e[1];
  if (a) {
    var o = window.getComputedStyle(r).getPropertyValue(a);
    return o ? o.trim() : cr(i) ? vr(i, r) : i;
  }
}
function Ji(t, r, n) {
  var e, a = J(r, []), i = t.getInstance();
  if (!(i instanceof HTMLElement))
    return { target: a, transitionEnd: n };
  n && (n = T({}, n)), t.forEachValue(function(s) {
    var c = s.get();
    if (cr(c)) {
      var p = vr(c, i);
      p && s.set(p);
    }
  });
  for (var o in a) {
    var u = a[o];
    if (cr(u)) {
      var f = vr(u, i);
      f && (a[o] = f, n && ((e = n[o]) !== null && e !== void 0 || (n[o] = u)));
    }
  }
  return { target: a, transitionEnd: n };
}
function sn(t, r) {
  return t / (r.max - r.min) * 100;
}
function Qi(t, r, n) {
  var e = n.target;
  if (typeof t == "string")
    if (pt.test(t))
      t = parseFloat(t);
    else
      return t;
  var a = sn(t, e.x), i = sn(t, e.y);
  return a + "% " + i + "%";
}
var fn = "_$css";
function ki(t, r) {
  var n = r.delta, e = r.treeScale, a = t, i = t.includes("var("), o = [];
  i && (t = t.replace(de, function(P) {
    return o.push(P), fn;
  }));
  var u = _t.parse(t);
  if (u.length > 5)
    return a;
  var f = _t.createTransformer(t), s = typeof u[0] != "number" ? 1 : 0, c = n.x.scale * e.x, p = n.y.scale * e.y;
  u[0 + s] /= c, u[1 + s] /= p;
  var v = z(c, p, 0.5);
  typeof u[2 + s] == "number" && (u[2 + s] /= v), typeof u[3 + s] == "number" && (u[3 + s] /= v);
  var g = f(u);
  if (i) {
    var l = 0;
    g = g.replace(fn, function() {
      var P = o[l];
      return l++, P;
    });
  }
  return g;
}
var ht = {
  process: Qi
}, to = {
  borderRadius: T(T({}, ht), { applyTo: [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ] }),
  borderTopLeftRadius: ht,
  borderTopRightRadius: ht,
  borderBottomLeftRadius: ht,
  borderBottomRightRadius: ht,
  boxShadow: {
    process: ki
  }
}, ln = 1e3, ro = (
  /** @class */
  function(t) {
    Tn(r, t);
    function r() {
      var n = t !== null && t.apply(this, arguments) || this;
      return n.frameTarget = tt(), n.currentAnimationTarget = tt(), n.isAnimating = {
        x: !1,
        y: !1
      }, n.stopAxisAnimation = {
        x: void 0,
        y: void 0
      }, n.isAnimatingTree = !1, n.animate = function(e, a, i) {
        i === void 0 && (i = {});
        var o = i.originBox, u = i.targetBox, f = i.visibilityAction, s = i.shouldStackAnimate, c = i.onComplete, p = i.prevParent, v = J(i, ["originBox", "targetBox", "visibilityAction", "shouldStackAnimate", "onComplete", "prevParent"]), g = n.props, l = g.visualElement, P = g.layout;
        if (s === !1)
          return n.isAnimatingTree = !1, n.safeToRemove();
        if (!(n.isAnimatingTree && s !== !0)) {
          s && (n.isAnimatingTree = !0), a = o || a, e = u || e;
          var m = !1, h = l.getProjectionParent();
          if (h) {
            var V = h.prevViewportBox, C = h.getLayoutState().layout;
            p && (u && (C = p.getLayoutState().layout), o && !Oi(p, h) && p.prevViewportBox && (V = p.prevViewportBox)), V && io(p, o, u) && (m = !0, a = gt(V, a), e = gt(C, e));
          }
          var w = eo(a, e), b = O(function(S) {
            var M, L;
            if (P === "position") {
              var A = e[S].max - e[S].min;
              a[S].max = a[S].min + A;
            }
            if (!l.projection.isTargetLocked)
              if (f !== void 0)
                l.setVisibility(f === lr.Show);
              else return w ? n.animateAxis(S, e[S], a[S], T(T({}, v), { isRelative: m })) : ((L = (M = n.stopAxisAnimation)[S]) === null || L === void 0 || L.call(M), l.setProjectionTargetAxis(S, e[S].min, e[S].max, m));
          });
          return l.syncRender(), Promise.all(b).then(function() {
            n.isAnimatingTree = !1, c && c(), l.notifyLayoutAnimationComplete();
          });
        }
      }, n;
    }
    return r.prototype.componentDidMount = function() {
      var n = this, e = this.props.visualElement;
      e.animateMotionValue = Ot, e.enableLayoutProjection(), this.unsubLayoutReady = e.onLayoutUpdate(this.animate), e.layoutSafeToRemove = function() {
        return n.safeToRemove();
      }, fa(to);
    }, r.prototype.componentWillUnmount = function() {
      var n = this;
      this.unsubLayoutReady(), O(function(e) {
        var a, i;
        return (i = (a = n.stopAxisAnimation)[e]) === null || i === void 0 ? void 0 : i.call(a);
      });
    }, r.prototype.animateAxis = function(n, e, a, i) {
      var o = this, u, f, s = i === void 0 ? {} : i, c = s.transition, p = s.isRelative;
      if (!(this.isAnimating[n] && St(e, this.currentAnimationTarget[n]))) {
        (f = (u = this.stopAxisAnimation)[n]) === null || f === void 0 || f.call(u), this.isAnimating[n] = !0;
        var v = this.props.visualElement, g = this.frameTarget[n], l = v.getProjectionAnimationProgress()[n];
        l.clearListeners(), l.set(0), l.set(0);
        var P = function() {
          var C = l.get() / ln;
          _i(g, a, e, C), v.setProjectionTargetAxis(n, g.min, g.max, p);
        };
        P();
        var m = l.onChange(P);
        this.stopAxisAnimation[n] = function() {
          o.isAnimating[n] = !1, l.stop(), m();
        }, this.currentAnimationTarget[n] = e;
        var h = c || v.getDefaultTransition() || ao, V = Ot(n === "x" ? "layoutX" : "layoutY", l, ln, h && je(h, "layout")).then(this.stopAxisAnimation[n]);
        return V;
      }
    }, r.prototype.safeToRemove = function() {
      var n, e;
      (e = (n = this.props).safeToRemove) === null || e === void 0 || e.call(n);
    }, r.prototype.render = function() {
      return null;
    }, r;
  }(dt.Component)
);
function no(t) {
  var r = B(bn(), 2), n = r[1];
  return dt.createElement(ro, T({}, t, { safeToRemove: n }));
}
function eo(t, r) {
  return !vn(t) && !vn(r) && (!St(t.x, r.x) || !St(t.y, r.y));
}
var cn = { min: 0, max: 0 };
function vn(t) {
  return St(t.x, cn) && St(t.y, cn);
}
function St(t, r) {
  return t.min === r.min && t.max === r.max;
}
var ao = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
function io(t, r, n) {
  return t || !t && !(r || n);
}
var oo = {
  layoutReady: function(t) {
    return t.notifyLayoutReady();
  }
};
function me() {
  var t = /* @__PURE__ */ new Set();
  return {
    add: function(r) {
      return t.add(r);
    },
    flush: function(r) {
      var n = r === void 0 ? oo : r, e = n.layoutReady, a = n.parent;
      sr(function(i, o) {
        var u = Array.from(t).sort(Lr), f = a ? Kt(a) : [];
        o(function() {
          var s = X(X([], B(f)), B(u));
          s.forEach(function(c) {
            return c.resetTransform();
          });
        }), i(function() {
          u.forEach(jt);
        }), o(function() {
          f.forEach(function(s) {
            return s.restoreTransform();
          }), u.forEach(e);
        }), i(function() {
          u.forEach(function(s) {
            s.isPresent && (s.presence = At.Present);
          });
        }), o(function() {
          vt.preRender(), vt.render();
        }), i(function() {
          ot.postRender(function() {
            return u.forEach(uo);
          }), t.clear();
        });
      }), fr();
    }
  };
}
function uo(t) {
  t.prevViewportBox = t.projection.target;
}
var so = ft(me()), fo = ft(me());
function ct(t) {
  return !!t.forceUpdate;
}
var lo = (
  /** @class */
  function(t) {
    Tn(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.componentDidMount = function() {
      var n = this.props, e = n.syncLayout, a = n.framerSyncLayout, i = n.visualElement;
      ct(e) && e.register(i), ct(a) && a.register(i), i.onUnmount(function() {
        ct(e) && e.remove(i), ct(a) && a.remove(i);
      });
    }, r.prototype.getSnapshotBeforeUpdate = function() {
      var n = this.props, e = n.syncLayout, a = n.visualElement;
      return ct(e) ? e.syncUpdate() : (Ii(a), e.add(a)), null;
    }, r.prototype.componentDidUpdate = function() {
      var n = this.props.syncLayout;
      ct(n) || n.flush();
    }, r.prototype.render = function() {
      return null;
    }, r;
  }(Vn.Component)
);
function co(t) {
  var r = _(so), n = _(fo);
  return Vn.createElement(lo, T({}, t, { syncLayout: r, framerSyncLayout: n }));
}
var vo = {
  measureLayout: co,
  layoutAnimation: no
}, mo = function() {
  return {
    isEnabled: !1,
    isHydrated: !1,
    isTargetLocked: !1,
    target: tt(),
    targetFinal: tt()
  };
};
function ge() {
  return {
    isHydrated: !1,
    layout: tt(),
    layoutCorrected: tt(),
    treeScale: { x: 1, y: 1 },
    delta: Xr(),
    deltaFinal: Xr(),
    deltaTransform: ""
  };
}
var dn = ge();
function qt(t, r, n) {
  var e = t.x, a = t.y, i = e.translate / r.x, o = a.translate / r.y, u = "translate3d(" + i + "px, " + o + "px, 0) ";
  if (n) {
    var f = n.rotate, s = n.rotateX, c = n.rotateY;
    f && (u += "rotate(" + f + ") "), s && (u += "rotateX(" + s + ") "), c && (u += "rotateY(" + c + ") ");
  }
  return u += "scale(" + e.scale + ", " + a.scale + ")", !n && u === go ? "" : u;
}
function pe(t) {
  var r = t.deltaFinal;
  return r.x.origin * 100 + "% " + r.y.origin * 100 + "% 0";
}
var go = qt(dn.delta, dn.treeScale, { x: 1, y: 1 }), Bt = [
  "LayoutMeasure",
  "BeforeLayoutMeasure",
  "LayoutUpdate",
  "ViewportBoxUpdate",
  "Update",
  "Render",
  "AnimationComplete",
  "LayoutAnimationComplete",
  "AnimationStart",
  "SetAxisTarget",
  "Unmount"
];
function po() {
  var t = Bt.map(function() {
    return new Ie();
  }), r = {}, n = {
    clearAllListeners: function() {
      return t.forEach(function(e) {
        return e.clear();
      });
    },
    updatePropListeners: function(e) {
      return Bt.forEach(function(a) {
        var i;
        (i = r[a]) === null || i === void 0 || i.call(r);
        var o = "on" + a, u = e[o];
        u && (r[a] = n[o](u));
      });
    }
  };
  return t.forEach(function(e, a) {
    n["on" + Bt[a]] = function(i) {
      return e.add(i);
    }, n["notify" + Bt[a]] = function() {
      for (var i = [], o = 0; o < arguments.length; o++)
        i[o] = arguments[o];
      return e.notify.apply(e, X([], B(i)));
    };
  }), n;
}
function ho(t, r, n) {
  var e;
  for (var a in r) {
    var i = r[a], o = n[a];
    if (k(i))
      t.addValue(a, i);
    else if (k(o))
      t.addValue(a, ut(i));
    else if (o !== i)
      if (t.hasValue(a)) {
        var u = t.getValue(a);
        !u.hasAnimated && u.set(i);
      } else
        t.addValue(a, ut((e = t.getStaticValue(a)) !== null && e !== void 0 ? e : i));
  }
  for (var a in n)
    r[a] === void 0 && t.removeValue(a);
  return r;
}
function yo(t, r, n, e) {
  var a = t.delta, i = t.layout, o = t.layoutCorrected, u = t.treeScale, f = r.target;
  Hi(o, i), Ni(o, u, n), ue(a, o, f, e);
}
var Po = (
  /** @class */
  function() {
    function t() {
      this.children = [], this.isDirty = !1;
    }
    return t.prototype.add = function(r) {
      _e(this.children, r), this.isDirty = !0;
    }, t.prototype.remove = function(r) {
      Oe(this.children, r), this.isDirty = !0;
    }, t.prototype.forEach = function(r) {
      this.isDirty && this.children.sort(Lr), this.isDirty = !1, this.children.forEach(r);
    }, t;
  }()
);
function To(t) {
  var r = t.getProjectionParent();
  if (!r) {
    t.rebaseProjectionTarget();
    return;
  }
  var n = gt(r.getLayoutState().layout, t.getLayoutState().layout);
  O(function(e) {
    t.setProjectionTargetAxis(e, n[e].min, n[e].max, !0);
  });
}
var he = function(t) {
  var r = t.treeType, n = r === void 0 ? "" : r, e = t.build, a = t.getBaseTarget, i = t.makeTargetAnimatable, o = t.measureViewportBox, u = t.render, f = t.readValueFromInstance, s = t.resetTransform, c = t.restoreTransform, p = t.removeValueFromRenderState, v = t.sortNodePosition, g = t.scrapeMotionValuesFromProps;
  return function(l, P) {
    var m = l.parent, h = l.props, V = l.presenceId, C = l.blockInitialAnimation, w = l.visualState;
    P === void 0 && (P = {});
    var b = w.latestValues, S = w.renderState, M, L = po(), A = mo(), F, H = A, $ = b, K, j = ge(), rt, q = !1, Q = /* @__PURE__ */ new Map(), nt = /* @__PURE__ */ new Map(), Lt = {}, et, U = T({}, b), Y;
    function at() {
      M && (x.isProjectionReady() && (ur(H.targetFinal, H.target, $), ue(j.deltaFinal, j.layoutCorrected, H.targetFinal, b)), it(), u(M, S));
    }
    function it() {
      var d = b;
      if (rt && rt.isActive()) {
        var y = rt.getCrossfadeState(x);
        y && (d = y);
      }
      e(x, S, d, H, j, P, h);
    }
    function Cr() {
      L.notifyUpdate(b);
    }
    function Ve() {
      if (x.isProjectionReady()) {
        var d = j.delta, y = j.treeScale, E = y.x, R = y.y, I = j.deltaTransform;
        yo(j, H, x.path, b), q && x.notifyViewportBoxUpdate(H.target, d), q = !1;
        var N = qt(d, y);
        (N !== I || // Also compare calculated treeScale, for values that rely on this only for scale correction
        E !== y.x || R !== y.y) && x.scheduleRender(), j.deltaTransform = N;
      }
    }
    function Ae() {
      x.layoutTree.forEach(Vo);
    }
    function Se(d, y) {
      var E = y.onChange(function(I) {
        b[d] = I, h.onUpdate && ot.update(Cr, !1, !0);
      }), R = y.onRenderRequest(x.scheduleRender);
      nt.set(d, function() {
        E(), R();
      });
    }
    var Er = g(h);
    for (var Wt in Er) {
      var wr = Er[Wt];
      b[Wt] !== void 0 && k(wr) && wr.set(b[Wt], !1);
    }
    var Mr = Zt(h), Jt = En(h), x = T(T({
      treeType: n,
      /**
       * This is a mirror of the internal instance prop, which keeps
       * VisualElement type-compatible with React's RefObject.
       */
      current: null,
      /**
       * The depth of this visual element within the visual element tree.
       */
      depth: m ? m.depth + 1 : 0,
      parent: m,
      children: /* @__PURE__ */ new Set(),
      /**
       * An ancestor path back to the root visual element. This is used
       * by layout projection to quickly recurse back up the tree.
       */
      path: m ? X(X([], B(m.path)), [m]) : [],
      layoutTree: m ? m.layoutTree : new Po(),
      /**
       *
       */
      presenceId: V,
      projection: A,
      /**
       * If this component is part of the variant tree, it should track
       * any children that are also part of the tree. This is essentially
       * a shadow tree to simplify logic around how to stagger over children.
       */
      variantChildren: Jt ? /* @__PURE__ */ new Set() : void 0,
      /**
       * Whether this instance is visible. This can be changed imperatively
       * by AnimateSharedLayout, is analogous to CSS's visibility in that
       * hidden elements should take up layout, and needs enacting by the configured
       * render function.
       */
      isVisible: void 0,
      /**
       * Normally, if a component is controlled by a parent's variants, it can
       * rely on that ancestor to trigger animations further down the tree.
       * However, if a component is created after its parent is mounted, the parent
       * won't trigger that mount animation so the child needs to.
       *
       * TODO: This might be better replaced with a method isParentMounted
       */
      manuallyAnimateOnMount: !!(m != null && m.isMounted()),
      /**
       * This can be set by AnimatePresence to force components that mount
       * at the same time as it to mount as if they have initial={false} set.
       */
      blockInitialAnimation: C,
      /**
       * Determine whether this component has mounted yet. This is mostly used
       * by variant children to determine whether they need to trigger their
       * own animations on mount.
       */
      isMounted: function() {
        return !!M;
      },
      mount: function(d) {
        M = x.current = d, x.pointTo(x), Jt && m && !Mr && (Y = m == null ? void 0 : m.addVariantChild(x)), m == null || m.children.add(x);
      },
      /**
       *
       */
      unmount: function() {
        Ft.update(Cr), Ft.render(at), Ft.preRender(x.updateLayoutProjection), nt.forEach(function(d) {
          return d();
        }), x.stopLayoutAnimation(), x.layoutTree.remove(x), Y == null || Y(), m == null || m.children.delete(x), K == null || K(), L.clearAllListeners();
      },
      /**
       * Add a child visual element to our set of children.
       */
      addVariantChild: function(d) {
        var y, E = x.getClosestVariantNode();
        if (E)
          return (y = E.variantChildren) === null || y === void 0 || y.add(d), function() {
            return E.variantChildren.delete(d);
          };
      },
      sortNodePosition: function(d) {
        return !v || n !== d.treeType ? 0 : v(x.getInstance(), d.getInstance());
      },
      /**
       * Returns the closest variant node in the tree starting from
       * this visual element.
       */
      getClosestVariantNode: function() {
        return Jt ? x : m == null ? void 0 : m.getClosestVariantNode();
      },
      /**
       * A method that schedules an update to layout projections throughout
       * the tree. We inherit from the parent so there's only ever one
       * job scheduled on the next frame - that of the root visual element.
       */
      scheduleUpdateLayoutProjection: m ? m.scheduleUpdateLayoutProjection : function() {
        return ot.preRender(x.updateTreeLayoutProjection, !1, !0);
      },
      /**
       * Expose the latest layoutId prop.
       */
      getLayoutId: function() {
        return h.layoutId;
      },
      /**
       * Returns the current instance.
       */
      getInstance: function() {
        return M;
      },
      /**
       * Get/set the latest static values.
       */
      getStaticValue: function(d) {
        return b[d];
      },
      setStaticValue: function(d, y) {
        return b[d] = y;
      },
      /**
       * Returns the latest motion value state. Currently only used to take
       * a snapshot of the visual element - perhaps this can return the whole
       * visual state
       */
      getLatestValues: function() {
        return b;
      },
      /**
       * Set the visiblity of the visual element. If it's changed, schedule
       * a render to reflect these changes.
       */
      setVisibility: function(d) {
        x.isVisible !== d && (x.isVisible = d, x.scheduleRender());
      },
      /**
       * Make a target animatable by Popmotion. For instance, if we're
       * trying to animate width from 100px to 100vw we need to measure 100vw
       * in pixels to determine what we really need to animate to. This is also
       * pluggable to support Framer's custom value types like Color,
       * and CSS variables.
       */
      makeTargetAnimatable: function(d, y) {
        return y === void 0 && (y = !0), i(x, d, h, y);
      },
      // Motion values ========================
      /**
       * Add a motion value and bind it to this visual element.
       */
      addValue: function(d, y) {
        x.hasValue(d) && x.removeValue(d), Q.set(d, y), b[d] = y.get(), Se(d, y);
      },
      /**
       * Remove a motion value and unbind any active subscriptions.
       */
      removeValue: function(d) {
        var y;
        Q.delete(d), (y = nt.get(d)) === null || y === void 0 || y(), nt.delete(d), delete b[d], p(d, S);
      },
      /**
       * Check whether we have a motion value for this key
       */
      hasValue: function(d) {
        return Q.has(d);
      },
      /**
       * Get a motion value for this key. If called with a default
       * value, we'll create one if none exists.
       */
      getValue: function(d, y) {
        var E = Q.get(d);
        return E === void 0 && y !== void 0 && (E = ut(y), x.addValue(d, E)), E;
      },
      /**
       * Iterate over our motion values.
       */
      forEachValue: function(d) {
        return Q.forEach(d);
      },
      /**
       * If we're trying to animate to a previously unencountered value,
       * we need to check for it in our state and as a last resort read it
       * directly from the instance (which might have performance implications).
       */
      readValue: function(d) {
        var y;
        return (y = b[d]) !== null && y !== void 0 ? y : f(M, d, P);
      },
      /**
       * Set the base target to later animate back to. This is currently
       * only hydrated on creation and when we first read a value.
       */
      setBaseTarget: function(d, y) {
        U[d] = y;
      },
      /**
       * Find the base target for a value thats been removed from all animation
       * props.
       */
      getBaseTarget: function(d) {
        if (a) {
          var y = a(h, d);
          if (y !== void 0 && !k(y))
            return y;
        }
        return U[d];
      }
    }, L), {
      /**
       * Build the renderer state based on the latest visual state.
       */
      build: function() {
        return it(), S;
      },
      /**
       * Schedule a render on the next animation frame.
       */
      scheduleRender: function() {
        ot.render(at, !1, !0);
      },
      /**
       * Synchronously fire render. It's prefered that we batch renders but
       * in many circumstances, like layout measurement, we need to run this
       * synchronously. However in those instances other measures should be taken
       * to batch reads/writes.
       */
      syncRender: at,
      /**
       * Update the provided props. Ensure any newly-added motion values are
       * added to our map, old ones removed, and listeners updated.
       */
      setProps: function(d) {
        h = d, L.updatePropListeners(d), Lt = ho(x, g(h), Lt);
      },
      getProps: function() {
        return h;
      },
      // Variants ==============================
      /**
       * Returns the variant definition with a given name.
       */
      getVariant: function(d) {
        var y;
        return (y = h.variants) === null || y === void 0 ? void 0 : y[d];
      },
      /**
       * Returns the defined default transition on this component.
       */
      getDefaultTransition: function() {
        return h.transition;
      },
      /**
       * Used by child variant nodes to get the closest ancestor variant props.
       */
      getVariantContext: function(d) {
        if (d === void 0 && (d = !1), d)
          return m == null ? void 0 : m.getVariantContext();
        if (!Mr) {
          var y = (m == null ? void 0 : m.getVariantContext()) || {};
          return h.initial !== void 0 && (y.initial = h.initial), y;
        }
        for (var E = {}, R = 0; R < Ao; R++) {
          var I = ye[R], N = h[I];
          (G(N) || N === !1) && (E[I] = N);
        }
        return E;
      },
      // Layout projection ==============================
      /**
       * Enable layout projection for this visual element. Won't actually
       * occur until we also have hydrated layout measurements.
       */
      enableLayoutProjection: function() {
        A.isEnabled = !0, x.layoutTree.add(x);
      },
      /**
       * Lock the projection target, for instance when dragging, so
       * nothing else can try and animate it.
       */
      lockProjectionTarget: function() {
        A.isTargetLocked = !0;
      },
      unlockProjectionTarget: function() {
        x.stopLayoutAnimation(), A.isTargetLocked = !1;
      },
      getLayoutState: function() {
        return j;
      },
      setCrossfader: function(d) {
        rt = d;
      },
      isProjectionReady: function() {
        return A.isEnabled && A.isHydrated && j.isHydrated;
      },
      /**
       * Start a layout animation on a given axis.
       */
      startLayoutAnimation: function(d, y, E) {
        E === void 0 && (E = !1);
        var R = x.getProjectionAnimationProgress()[d], I = E ? A.relativeTarget[d] : A.target[d], N = I.min, Ct = I.max, Et = Ct - N;
        return R.clearListeners(), R.set(N), R.set(N), R.onChange(function(wt) {
          x.setProjectionTargetAxis(d, wt, wt + Et, E);
        }), x.animateMotionValue(d, R, 0, y);
      },
      /**
       * Stop layout animations.
       */
      stopLayoutAnimation: function() {
        O(function(d) {
          return x.getProjectionAnimationProgress()[d].stop();
        });
      },
      /**
       * Measure the current viewport box with or without transforms.
       * Only measures axis-aligned boxes, rotate and skew must be manually
       * removed with a re-render to work.
       */
      measureViewportBox: function(d) {
        d === void 0 && (d = !0);
        var y = o(M, P);
        return d || ve(y, b), y;
      },
      /**
       * Get the motion values tracking the layout animations on each
       * axis. Lazy init if not already created.
       */
      getProjectionAnimationProgress: function() {
        return et || (et = {
          x: ut(0),
          y: ut(0)
        }), et;
      },
      /**
       * Update the projection of a single axis. Schedule an update to
       * the tree layout projection.
       */
      setProjectionTargetAxis: function(d, y, E, R) {
        R === void 0 && (R = !1);
        var I;
        R ? (A.relativeTarget || (A.relativeTarget = tt()), I = A.relativeTarget[d]) : (A.relativeTarget = void 0, I = A.target[d]), A.isHydrated = !0, I.min = y, I.max = E, q = !0, L.notifySetAxisTarget();
      },
      /**
       * Rebase the projection target on top of the provided viewport box
       * or the measured layout. This ensures that non-animating elements
       * don't fall out of sync differences in measurements vs projections
       * after a page scroll or other relayout.
       */
      rebaseProjectionTarget: function(d, y) {
        y === void 0 && (y = j.layout);
        var E = x.getProjectionAnimationProgress(), R = E.x, I = E.y, N = !A.relativeTarget && !A.isTargetLocked && !R.isAnimating() && !I.isAnimating();
        (d || N) && O(function(Ct) {
          var Et = y[Ct], wt = Et.min, be = Et.max;
          x.setProjectionTargetAxis(Ct, wt, be);
        });
      },
      /**
       * Notify the visual element that its layout is up-to-date.
       * Currently Animate.tsx uses this to check whether a layout animation
       * needs to be performed.
       */
      notifyLayoutReady: function(d) {
        To(x), x.notifyLayoutUpdate(j.layout, x.prevViewportBox || j.layout, d);
      },
      /**
       * Temporarily reset the transform of the instance.
       */
      resetTransform: function() {
        return s(x, M, h);
      },
      restoreTransform: function() {
        return c(M, S);
      },
      updateLayoutProjection: Ve,
      updateTreeLayoutProjection: function() {
        x.layoutTree.forEach(xo), ot.preRender(Ae, !1, !0);
      },
      getProjectionParent: function() {
        if (F === void 0) {
          for (var d = !1, y = x.path.length - 1; y >= 0; y--) {
            var E = x.path[y];
            if (E.projection.isEnabled) {
              d = E;
              break;
            }
          }
          F = d;
        }
        return F;
      },
      resolveRelativeTargetBox: function() {
        var d = x.getProjectionParent();
        if (!(!A.relativeTarget || !d) && (Fi(A, d.projection), fe(d))) {
          var y = A.target;
          ur(y, y, d.getLatestValues());
        }
      },
      shouldResetTransform: function() {
        return !!h._layoutResetTransform;
      },
      /**
       *
       */
      pointTo: function(d) {
        H = d.projection, $ = d.getLatestValues(), K == null || K(), K = dr(d.onSetAxisTarget(x.scheduleUpdateLayoutProjection), d.onLayoutAnimationComplete(function() {
          var y;
          x.isPresent ? x.presence = At.Present : (y = x.layoutSafeToRemove) === null || y === void 0 || y.call(x);
        }));
      },
      // TODO: Clean this up
      isPresent: !0,
      presence: At.Entering
    });
    return x;
  };
};
function xo(t) {
  t.resolveRelativeTargetBox();
}
function Vo(t) {
  t.updateLayoutProjection();
}
var ye = X(["initial"], B(br)), Ao = ye.length, So = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]), Pe = function(t) {
  return So.has(t);
}, bo = function(t) {
  return Object.keys(t).some(Pe);
}, Te = function(t, r) {
  t.set(r, !1), t.set(r);
}, mn = function(t) {
  return t === Pn || t === pt;
}, gn;
(function(t) {
  t.width = "width", t.height = "height", t.left = "left", t.right = "right", t.top = "top", t.bottom = "bottom";
})(gn || (gn = {}));
var pn = function(t, r) {
  return parseFloat(t.split(", ")[r]);
}, hn = function(t, r) {
  return function(n, e) {
    var a = e.transform;
    if (a === "none" || !a)
      return 0;
    var i = a.match(/^matrix3d\((.+)\)$/);
    if (i)
      return pn(i[1], r);
    var o = a.match(/^matrix\((.+)\)$/);
    return o ? pn(o[1], t) : 0;
  };
}, Lo = /* @__PURE__ */ new Set(["x", "y", "z"]), Co = xt.filter(function(t) {
  return !Lo.has(t);
});
function Eo(t) {
  var r = [];
  return Co.forEach(function(n) {
    var e = t.getValue(n);
    e !== void 0 && (r.push([n, e.get()]), e.set(n.startsWith("scale") ? 1 : 0));
  }), r.length && t.syncRender(), r;
}
var yn = {
  // Dimensions
  width: function(t) {
    var r = t.x;
    return r.max - r.min;
  },
  height: function(t) {
    var r = t.y;
    return r.max - r.min;
  },
  top: function(t, r) {
    var n = r.top;
    return parseFloat(n);
  },
  left: function(t, r) {
    var n = r.left;
    return parseFloat(n);
  },
  bottom: function(t, r) {
    var n = t.y, e = r.top;
    return parseFloat(e) + (n.max - n.min);
  },
  right: function(t, r) {
    var n = t.x, e = r.left;
    return parseFloat(e) + (n.max - n.min);
  },
  // Transform
  x: hn(4, 13),
  y: hn(5, 14)
}, wo = function(t, r, n) {
  var e = r.measureViewportBox(), a = r.getInstance(), i = getComputedStyle(a), o = i.display, u = i.top, f = i.left, s = i.bottom, c = i.right, p = i.transform, v = { top: u, left: f, bottom: s, right: c, transform: p };
  o === "none" && r.setStaticValue("display", t.display || "block"), r.syncRender();
  var g = r.measureViewportBox();
  return n.forEach(function(l) {
    var P = r.getValue(l);
    Te(P, yn[l](e, v)), t[l] = yn[l](g, i);
  }), t;
}, Mo = function(t, r, n, e) {
  n === void 0 && (n = {}), e === void 0 && (e = {}), r = T({}, r), e = T({}, e);
  var a = Object.keys(r).filter(Pe), i = [], o = !1, u = [];
  if (a.forEach(function(s) {
    var c = t.getValue(s);
    if (t.hasValue(s)) {
      var p = n[s], v = r[s], g = Dt(p), l;
      if (It(v))
        for (var P = v.length, m = v[0] === null ? 1 : 0; m < P; m++)
          l ? He(Dt(v[m]) === l) : l = Dt(v[m]);
      else
        l = Dt(v);
      if (g !== l)
        if (mn(g) && mn(l)) {
          var h = c.get();
          typeof h == "string" && c.set(parseFloat(h)), typeof v == "string" ? r[s] = parseFloat(v) : Array.isArray(v) && l === pt && (r[s] = v.map(parseFloat));
        } else g != null && g.transform && (l != null && l.transform) && (p === 0 || v === 0) ? p === 0 ? c.set(l.transform(p)) : r[s] = g.transform(v) : (o || (i = Eo(t), o = !0), u.push(s), e[s] = e[s] !== void 0 ? e[s] : r[s], Te(c, v));
    }
  }), u.length) {
    var f = wo(r, t, u);
    return i.length && i.forEach(function(s) {
      var c = B(s, 2), p = c[0], v = c[1];
      t.getValue(p).set(v);
    }), t.syncRender(), { target: f, transitionEnd: e };
  } else
    return { target: r, transitionEnd: e };
};
function Do(t, r, n, e) {
  return bo(r) ? Mo(t, r, n, e) : { target: r, transitionEnd: e };
}
var Ro = function(t, r, n, e) {
  var a = Ji(t, r, e);
  return r = a.target, e = a.transitionEnd, Do(t, r, n, e);
};
function Bo(t) {
  return window.getComputedStyle(t);
}
var xe = {
  treeType: "dom",
  readValueFromInstance: function(t, r) {
    if ($t(r)) {
      var n = xn(r);
      return n && n.default || 0;
    } else {
      var e = Bo(t);
      return (Dn(r) ? e.getPropertyValue(r) : e[r]) || 0;
    }
  },
  sortNodePosition: function(t, r) {
    return t.compareDocumentPosition(r) & 2 ? 1 : -1;
  },
  getBaseTarget: function(t, r) {
    var n;
    return (n = t.style) === null || n === void 0 ? void 0 : n[r];
  },
  measureViewportBox: function(t, r) {
    var n = r.transformPagePoint;
    return oe(t, n);
  },
  /**
   * Reset the transform on the current Element. This is called as part
   * of a batched process across the entire layout tree. To remove this write
   * cycle it'd be interesting to see if it's possible to "undo" all the current
   * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
   * works
   */
  resetTransform: function(t, r, n) {
    var e = n.transformTemplate;
    r.style.transform = e ? e({}, "") : "none", t.scheduleRender();
  },
  restoreTransform: function(t, r) {
    t.style.transform = r.style.transform;
  },
  removeValueFromRenderState: function(t, r) {
    var n = r.vars, e = r.style;
    delete n[t], delete e[t];
  },
  /**
   * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
   * can be animated by Motion.
   */
  makeTargetAnimatable: function(t, r, n, e) {
    var a = n.transformValues;
    e === void 0 && (e = !0);
    var i = r.transition, o = r.transitionEnd, u = J(r, ["transition", "transitionEnd"]), f = si(u, i || {}, t);
    if (a && (o && (o = a(o)), u && (u = a(u)), f && (f = a(f))), e) {
      oi(t, u, f);
      var s = Ro(t, u, f, o);
      o = s.transitionEnd, u = s.target;
    }
    return T({
      transition: i,
      transitionEnd: o
    }, u);
  },
  scrapeMotionValuesFromProps: xr,
  build: function(t, r, n, e, a, i, o) {
    t.isVisible !== void 0 && (r.style.visibility = t.isVisible ? "visible" : "hidden");
    var u = e.isEnabled && a.isHydrated;
    yr(r, n, e, a, i, o.transformTemplate, u ? qt : void 0, u ? pe : void 0);
  },
  render: In
}, Fo = he(xe), jo = he(T(T({}, xe), {
  getBaseTarget: function(t, r) {
    return t[r];
  },
  readValueFromInstance: function(t, r) {
    var n;
    return $t(r) ? ((n = xn(r)) === null || n === void 0 ? void 0 : n.default) || 0 : (r = _n.has(r) ? r : jn(r), t.getAttribute(r));
  },
  scrapeMotionValuesFromProps: Hn,
  build: function(t, r, n, e, a, i, o) {
    var u = e.isEnabled && a.isHydrated;
    Tr(r, n, e, a, i, o.transformTemplate, u ? qt : void 0, u ? pe : void 0);
  },
  render: On
})), Io = function(t, r) {
  return hr(t) ? jo(r, { enableHardwareAcceleration: !1 }) : Fo(r, { enableHardwareAcceleration: !0 });
}, _o = T(T(T(T({}, Pi), ka), qi), vo), Uo = /* @__PURE__ */ ua(function(t, r) {
  return Ha(t, r, _o, Io);
});
export {
  Xt as M,
  Yt as P,
  so as S,
  pr as a,
  ct as i,
  Uo as m,
  qn as u
};
//# sourceMappingURL=motion-B7Equlyg.mjs.map
